import React from "react";
import { Async } from "react-async";
import { FpLoadingIcon } from "@fortius/prime-ui";
import { i18next, changeLanguage } from "commons/locales";
import { useQueryParam } from "features/common/hooks";
import { useSystemLanguage } from "../hooks";

export const I18NextInit: React.FC<{
  children?: React.ReactNode;
  onInit?(): void;
}> = ({ children, onInit }) => {
  const languageQuery = useQueryParam("lang");
  const languageCode = useSystemLanguage(languageQuery);

  const init = React.useCallback(async () => {
    if (!i18next.isInitialized) {
      await i18next.init();
    }

    await changeLanguage(languageCode);
    onInit?.();
  }, [languageCode, onInit]);

  return (
    <Async promiseFn={init} watch={languageCode}>
      <Async.Loading>
        <FpLoadingIcon fullScreen />
      </Async.Loading>
      <Async.Settled>{children}</Async.Settled>
    </Async>
  );
};
